import React, { FC } from 'react'
import { useField } from 'formik'
import clsx from 'clsx'

import { ReactComponent as TooltipInfo } from 'assets/images/mini_tooltip.svg'
import { ReactComponent as Currency } from 'assets/images/currency.svg'
import { ReactComponent as ActCurrency } from 'assets/images/activeCurrency.svg'
import { CloseCircleFilled } from '@ant-design/icons'

import { Tooltip } from '@pepper/ui'

import styles from './_.module.css'

interface Props {
  name: string
  label?: string
  required?: boolean
  values: {
    label: string
    value: string | number
    details?: string
  }[]
  miniTooltip?: string
  disabled?: boolean
}

const WriterExpertise: FC<Props> = ({
  name,
  label,
  required,
  values,
  miniTooltip,
  disabled,
}) => {
  const [field, meta, helpers] = useField(name)
  const updateValue = (val: string | number) => {
    helpers.setValue(val)
  }
  const getStar = (count: number) => {
    return [1, 2, 3].map(item => {
      if (item <= count) {
        return <ActCurrency key={item} className={styles.currency} />
      }
      return <Currency key={item} className={styles.currency} />
    })
  }
  return (
    <div className={styles.writerWrap}>
      <div className={styles.lineWrap}>
        <span className={styles.labelText}>{label}</span>
        {required && <span className={styles.requiredText}>*</span>}
        {miniTooltip && (
          <Tooltip
            placement="top"
            title={() => (
              <div
                dangerouslySetInnerHTML={{
                  __html: miniTooltip,
                }}
              />
            )}
          >
            <TooltipInfo className={styles.tooltipPos} />
          </Tooltip>
        )}
      </div>
      <div className={styles.writerOptions}>
        {values.map((valueData, index) => {
          return (
            <div
              key={index}
              role="menuitem"
              tabIndex={index}
              onClick={() => !disabled && updateValue(valueData.value)}
              onKeyPress={() => !disabled && updateValue(valueData.value)}
              className={clsx(styles.writerOption, {
                [styles.writerOptionActive]: field.value === valueData.value,
                [styles.opionDisabled]: disabled,
              })}
            >
              <div className={styles.header}>{valueData.label}</div>
              <div className={styles.subHeader}>{valueData.details}</div>
              <div className={styles.starWrap}>
                {getStar(Number(valueData.value))}
              </div>
            </div>
          )
        })}
      </div>
      {meta.touched && meta.error ? (
        <div className={styles.error}>
          <CloseCircleFilled className={styles.errorIcon} /> {meta.error}
        </div>
      ) : null}
    </div>
  )
}

export default WriterExpertise
